import { ActionType, ProTable } from "@ant-design/pro-components";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import UUIDComponent from "../../components/UUIDComponent";
import { Button, Form, message, Modal, Select, Spin, Tag } from "antd";
import { loginChannel } from "../const";
import GlobalWrap from "../../components/globalWrap";
import UserMemberForm from "./UserMemberForm";
import UserMemberDetail from "./UserMemberDetail";
import dayjs from "dayjs";

export default function User() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();
    const [form] = Form.useForm();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "序号",
            valueType: "index",
            search: false,
            align: "center",
        },
        {
            title: "用户id",
            dataIndex: "id",
            align: "center",
            search: true,
            render: (value: any) => <UUIDComponent value={value} flag={true} />
        },
        {
            title: "最近登录渠道",
            dataIndex: "lastLoginChannel",
            align: "center",
            search: false,
            render: (text: string) => {
                const channelInfo = loginChannel[text as keyof typeof loginChannel];
                return <Tag color={channelInfo?.color}>
                    {channelInfo?.text || '未知'}
                </Tag>
            }
        },
        {
            title: "设备类型",
            dataIndex: "deviceType",
            align: "center",
            search: false,
            render: (text: string) => (
                <div>{text === 'IOS' ? 'ios' : text === 'ANDROID' ? '安卓' : '未知'}</div>
            )
        },
        {
            title: "联系电话",
            dataIndex: "phone",
            align: "center",
            search: false,
        },
        {
            title: "用户状态",
            dataIndex: "status",
            align: "center",
            search: false,
            render: (text: string) => {
                switch (text) {
                    case "NORMAL":
                        return <span style={{ color: 'green' }}>正常</span>;
                    case "WRITE_OFF":
                        return <span style={{ color: 'red' }}>注销</span>;
                    default:
                        return <span>未知</span>;
                }
            }
        },
        {
            title: "是否会员",
            dataIndex: "vipFlag",
            align: "center",
            search: true,
            render: (text: boolean, record: any) => {
                if (text) {
                    return (
                        <Button
                            type="link"
                            onClick={() => handleMemberDetail(record)}
                        >
                            是
                        </Button>
                    );
                }
                return <span>否</span>;
            },
            renderFormItem: () => <Select allowClear
                placeholder="请选择是否会员"
                options={[
                    { label: "是", value: true },
                    { label: "否", value: false },
                ]} />
        },
        {
            title: "是否永久会员",
            dataIndex: "vipPermanentFlag",
            align: "center",
            search: true,
            render: (text: boolean) => {
                if (text) return <span>是</span>;
                return <span>否</span>;
            },
            renderFormItem: () => <Select allowClear
                placeholder="请选择是否永久会员"
                options={[
                    { label: "是", value: true },
                    { label: "否", value: false },
                ]} />
        },
        {
            title: "会员到期时间",
            dataIndex: "vipExpireDate",
            align: "center",
            search: false,
            render: (text: any, record: any) => {
                if (record.vipPermanentFlag) {
                    return <span>-</span>;
                }
                const date = moment(text).endOf('day');
                return text && date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : text || '-';
            }
        },
        {
            title: "订阅会员支付宝协议号",
            dataIndex: "vipAlipayAgreementNo",
            align: "center",
            search: false,
        },
        {
            title: "设置会员期限",
            dataIndex: "memberExpiry",
            align: "center",
            search: false,
            render: (_: any, record: any) => {
                if (record.status === 'WRITE_OFF') {
                    return <span>-</span>;
                }
                return (
                    <Button
                        type="link"
                        onClick={() => handleAdd(record)}
                    >
                        设置
                    </Button>
                );
            }
        },
        {
            title: "设备id",
            dataIndex: "deviceId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} flag={true} />
        },
        {
            title: "用户中台id",
            dataIndex: "middleUserId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "九吨用户id",
            dataIndex: "ntUserId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "创建时间",
            dataIndex: "createAt",
            search: false,
            align: "center",
            render: (text: any) => {
                return moment(text).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        {
            title: "创建时间",
            dataIndex: "createAt",
            align: "center",
            search: true,
            hideInTable: true,
            valueType: "dateRange",
        },
        // {
        //     title: "操作",
        //     key: 'operation',
        //     search: false,
        //     align: "center",
        //     render: (_: any, record: any) => {
        //         if (record.vipFlag) {
        //             return <Popconfirm
        //                 title={`只有支付宝连续订阅才能进行解约操作，确定解约吗？`}
        //                 onConfirm={() => removeMember(record)}
        //                 okText="是"
        //                 cancelText="否"
        //             >
        //                 <Button type="link">
        //                     解约
        //                 </Button>
        //             </Popconfirm>
        //         }
        //         return null;
        //     },
        // }
    ];

    const handleMemberDetail = (item: any) => {
        Modal.confirm({
            width: 500,
            title: `会员详情 - ${item?.id}`,
            content: <GlobalWrap><UserMemberDetail item={item} /></GlobalWrap>,
            onOk: async (close) => {
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const handleAdd = (item: any) => {
        Modal.confirm({
            width: 500,
            title: `会员设置 - ${item.id}`,
            content: <GlobalWrap><UserMemberForm form={form} /></GlobalWrap>,
            onOk: async (close) => {
                let values = await form.validateFields();
                await jsonRequest.post("/back/health-user/set-up-vip", {
                    userId: item.id,
                    dueDate: values.dueDate ? dayjs(values.dueDate).format('YYYY-MM-DD') : null,
                    permanent: values.permanent ? values.permanent : null,
                }).then((resp: any) => resp.json())
                    .then((data: any) => {
                        if (data?.code === 0) {
                            message.success("设置成功");
                        } else {
                            message.error(data?.msg || "设置失败");
                        }
                    }
                    )
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const removeMember = async (id: any) => {
        const result: any = await jsonRequest.delete("/back/", {
            id: id
        });
        if (result?.body.code === 0)
            message.success('解约成功');
        else {
            message.error('解约失败');
            console.log(result);
        }
        tableRef.current?.reload();
    }

    const [expandedData, setExpandedData] = useState<any>([]);
    const [data, setData] = useState<any>([]);

    const getDetail = async (record: any) => {
        if (!expandedData[record?.id]) {
            record.loading = true;
            const result: any = await jsonRequest.get(`/back/health-user/channel/${record.id}`, {
            }).then((resp: any) => resp.json());
            record.loading = false;
            setExpandedData({ ...expandedData, [record?.id]: result.data });
            setData(result.data);
        };
    }

    const renderChannelUserInfo = (info: any): React.ReactNode => {
        if (!info) return String(info || '');

        if (typeof info === 'object') {
            return (
                <div style={{ marginLeft: '20px' }}>
                    {Object.keys(info).map((key) => (
                        <div key={key}>
                            {key}: {typeof info[key] === 'object' ? renderChannelUserInfo(info[key]) : String(info[key])}
                        </div>
                    ))}
                </div>
            );
        }

        return String(info);
    };

    const expandedRowRender = (record: any) => {
        if (record.loading) {
            return <Spin style={{ margin: '0 auto', width: '100%' }} />
        }
        let value = [];
        if (expandedData[record?.id]) {
            value = expandedData[record?.id];
        } else if (data.id === record?.id) {
            value = data;
        }

        if (!value || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && Object.keys(value).length === 0)) {
            return <div>暂无用户信息</div>;
        }

        return <div>
            {
                value?.map((item: any, index: number) => {
                    return (
                        <div key={index} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #f0f0f0' }}>
                            <div>渠道名称：{item?.channelKey}</div>
                            <div>
                                用户渠道信息：
                                {renderChannelUserInfo(item?.channelUserInfo)}
                            </div>
                        </div>
                    );
                })
            }
        </div>
    };
    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/health-user/page", {
            currentPage: params.current,
            pageSize: params.pageSize,
            queryBeginDate: params?.createAt?.[0],
            queryEndDate: params?.createAt?.[1],
            queryName: params?.id,
            vipFlag: params?.vipFlag,
            vipPermanentFlag: params?.vipPermanentFlag,
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>用户列表</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 2000 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false, labelWidth: 'auto' }}
            expandable={{
                onExpand: (expanded, record) => {
                    getDetail(record);
                },
                expandedRowRender
            }}
        />
    </>;
}